import { ErrorStatus } from './types';

interface ErrorConfig {
  title: string;
  description: string;
}

export const ERRORS_MAP: Record<ErrorStatus, ErrorConfig> = {
  403: {
    title: 'Access Forbidden',
    description:
      "You don't have permission to access this resource. This could be because you're not logged in, don't have the required role, or the content is restricted.",
  },
  404: {
    title: 'Page Not Found',
    description:
      "Sorry, we couldn't find the page you're looking for. It might have been moved, deleted, or you entered the wrong URL.",
  },
  500: {
    title: 'Oooops...',
    description:
      "Something went wrong on our end. We're sorry for the inconvenience and are working to fix this issue.",
  },
};
